import React, { useState, useEffect } from "react";
import "./ShowCertificate.scss";
import Modal from "../../../layouts/Modal/Modal";
import { Link } from "react-router-dom";
import ButtonComponent from "../../../Styles/Form/ButtonComponent";
import InputComponent from "../../../Styles/Form/InputComponent";
import Loading from "../../../layouts/Loading/Loading";
import axios from "axios";

function ShowCertificate() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const [showWeaveModal, setShowWeaveModal] = useState(false);
  const [showDimensionsModal, setShowDimensionsModal] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [newCertificate, setNewCertificate] = useState({});
  const [editCertificate, setEditeCertificate] = useState({});
  const [allCertificate, setAllCertificate] = useState(null);

  const editeGCertificateHandler = () => {
    axios
      .put(
        `https://carpet.bistatechnology.ir/api/v1/admin/certificate/${selectedItem.id}`,
        editCertificate
      )
      .then((res) => {
        console.log(res);
        getAllCertificate();
        alert("ویرایش انجام شد");
      })
      .catch(() => {
        alert("خطا");
      })
      .finally(() => {
        setShowEditModal(false);
        setSelectedItem(null);
        setEditeCertificate(null);
      });
  };

  const getAllCertificate = () => {
    axios
      .get("https://carpet.bistatechnology.ir/api/v1/admin/certificate")
      .then((res) => {
        setAllCertificate(res.data);
      })
      .catch(() => {
        alert("خطا در دریافت اطلاعات");
      });
  };

  const deleteCertificateHandler = () => {
    axios
      .delete(
        `https://carpet.bistatechnology.ir/api/v1/admin/certificate/${selectedItem.id}`
      )
      .then((res) => {
        console.log(res);
        getAllCertificate();
        setShowAddModal(false);
        alert("حذف شد");
      })
      .catch(() => {
        alert("خطا");
      })
      .finally(() => {
        setSelectedItem(null);
      });
  };

  useEffect(() => {
    getAllCertificate();
  }, []);

  const handleSelectRow = (item) => {
    setSelectedItem(item);
  };

  const deleteItemHandler = () => {
    if (window.confirm(` آیا فرش "${selectedItem.code}" حذف گردد؟`)) {
      deleteCertificateHandler();
    }
  };

  const changeEditeHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setEditeCertificate({ ...editCertificate, [name]: value });
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">لیست شناسنامه ها</h5>
        {showEditModal && (
          <Modal>
            <div className="d-flex flex-row flex-wrap">
              <InputComponent
                inputName="Certificate_id"
                inputId="Certificate_id"
                lableValue="ایدی فرش"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.category_id}
              />
              <InputComponent
                inputName="certificate_number"
                inputId="certificate_number"
                lableValue="شماره شناسنامه"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.certificate_number}
              />
              <InputComponent
                inputName="certificate_serial"
                inputId="certificate_serial"
                lableValue="سریال شناسنامه"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.certificate_serial}
              />
              <InputComponent
                inputName="code"
                inputId="code"
                lableValue="کد فرش:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.code}
              />
              <InputComponent
                inputName="years_creation"
                inputId="years_creation"
                lableValue="سال ایجاد:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.years_creation}
              />
              <InputComponent
                inputName="creator"
                inputId="creator"
                lableValue="پدیدآورنده:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.creator}
              />
              <InputComponent
                inputName="place_creation"
                inputId="place_creation"
                lableValue="محل ایجاد/بافت:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.place_creation}
              />
              <InputComponent
                inputName="designer"
                inputId="designer"
                lableValue="طراح:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.designer}
              />
              <InputComponent
                inputName="master_weaver"
                inputId="master_weaver"
                lableValue="استاد بافنده:"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.master_weaver}
              />
              <InputComponent
                inputName="weave_method"
                inputId="weave_method"
                lableValue="شیوه بافت"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.weave_method}
              />
              <InputComponent
                inputName="knot_type"
                inputId="knot_type"
                lableValue="نوع گره"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.knot_type}
              />
              <InputComponent
                inputName="pile_material"
                inputId="pile_material"
                lableValue="جنس پرز/گره"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.pile_material}
              />
              <InputComponent
                inputName="warp_material"
                inputId="warp_material"
                lableValue="جنس تار"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.warp_material}
              />
              <InputComponent
                inputName="weft_material"
                inputId="weft_material"
                lableValue="جنس پود"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.weft_material}
              />
              <InputComponent
                inputName="design_type"
                inputId="design_type"
                lableValue="نوع طرح"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.design_type}
              />
              <InputComponent
                inputName="design_name"
                inputId="design_name"
                lableValue="نام نقشه"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.design_name}
              />
              <InputComponent
                inputName="ground_color"
                inputId="ground_color"
                lableValue="رنگ متن"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.ground_color}
              />
              <InputComponent
                inputName="border_color"
                inputId="border_color"
                lableValue="رنگ حاشیه"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.border_color}
              />
              <InputComponent
                inputName="number_color"
                inputId="number_color"
                lableValue="تعداد رنگ"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.number_color}
              />
              <InputComponent
                inputName="width"
                inputId="width"
                lableValue="عرض به سانتی متر"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.width}
              />
              <InputComponent
                inputName="length"
                inputId="length"
                lableValue="طول به سانتی متر"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.length}
              />
              <InputComponent
                inputName="area"
                inputId="area"
                lableValue="مساحت مترمربع"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.area}
              />
              <InputComponent
                inputName="unit_raj"
                inputId="unit_raj"
                lableValue="مبدا رج به سانتی متر"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.unit_raj}
              />
              <InputComponent
                inputName="raj_counter"
                inputId="raj_counter"
                lableValue="رج شمار"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.raj_counter}
              />
              <InputComponent
                inputName="density"
                inputId="density"
                lableValue="تراکم در دسی متر مربع"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.density}
              />
              <InputComponent
                inputName="number_knots_width"
                inputId="number_knots_width"
                lableValue="تعداد گره در عرض"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.number_knots_width}
              />
              <InputComponent
                inputName="number_knot_length"
                inputId="number_knot_length"
                lableValue="تعداد گره در طول"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.number_knot_length}
              />
              <InputComponent
                inputName="total_number_knot"
                inputId="total_number_knot"
                lableValue="تعداد کل گره"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.total_number_knot}
              />
              <InputComponent
                inputName="man_hours_creation"
                inputId="man_hours_creation"
                lableValue="نفر ساعت تولید "
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.man_hours_creation}
              />
              <InputComponent
                inputName="number_weaver"
                inputId="number_weaver"
                lableValue="تعداد بافنده"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.number_weaver}
              />
              <InputComponent
                inputName="duration_creation"
                inputId="duration_creation"
                lableValue="مدت زمان تولید-ماه"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.duration_creation}
              />

              <InputComponent
                inputName="weight"
                inputId="weight"
                lableValue="وزن به کیلوگرم"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.weight}
              />
              <InputComponent
                inputName="seconder"
                inputId="seconder"
                lableValue="تاییدکننده"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.seconder}
              />
              <InputComponent
                inputName="description"
                inputId="description"
                lableValue="توضیحات"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.description}
              />
              <InputComponent
                inputName="transaction_code"
                inputId="transaction_code"
                lableValue="کد تراکنش"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.transaction_code}
              />
              <InputComponent
                inputName="date"
                inputId="date"
                lableValue="تاریخ"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.date}
              />
              <InputComponent
                inputName="owner_code"
                inputId="owner_code"
                lableValue="کد مالک "
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.owner_code}
              />
              <InputComponent
                inputName="owner_name"
                inputId="owner_name"
                lableValue="نام مالک"
                onChange={(e) => changeEditeHandler(e)}
                defaultValue={selectedItem.owner_name}
              />
              <ButtonComponent
                value="ثبت"
                onClick={() => editeGCertificateHandler()}
              />
              <ButtonComponent
                value="لغو"
                onClick={() => setShowEditModal(false)}
              />
            </div>
          </Modal>
        )}
        {showOwnerModal && (
          <Modal>
            <>
            <button
              style={{width:50 , border:"none" }}
                onClick={() => setShowOwnerModal(false)}
              >
                X
              </button>
              <table className="bi-table-style  col-12 col-md-6 col-lg-4">
                <thead>
                  <tr>
                    <th>تاییدکننده</th>
                    <th>پدیدآورنده</th>
                    <th>توضیحات</th>
                    <th>کد تراکنش</th>
                    <th>تاریخ</th>
                    <th>کد مالک</th>
                    <th>نام مالک</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{selectedItem.seconder}</td>
                    <td>{selectedItem.creator}</td>
                    <td>{selectedItem.description}</td>
                    <td>{selectedItem.transaction_code}</td>
                    <td>{selectedItem.date}</td>
                    <td>{selectedItem.owner_code}</td>
                    <td>{selectedItem.owner_name}</td>
                  </tr>
                </tbody>
              </table>

            </>
          </Modal>
        )}
        {showWeaveModal && (
          <Modal>
            <>
              <button
              style={{width:50 , border:"none" }}
                onClick={() => setShowWeaveModal(false)}
              >
                X
              </button>
              <table className="bi-table-style col-12 col-md-6 col-lg-4">
                <thead>
                  <tr>
                    <th>محل ایجاد/بافت</th>
                    <th>استاد بافنده</th>
                    <th>شیوه بافت</th>
                    <th>نوع گره</th>
                    <th>جنس پرز/گره</th>
                    <th>جنس تار</th>
                    <th>جنس پود</th>
                    <th>تعداد بافنده</th>
                    <th>تعداد رنگ</th>
                    <th>رنگ حاشیه</th>
                    <th>رنگ متن</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{selectedItem.place_creation}</td>
                    <td>{selectedItem.master_weaver}</td>
                    <td>{selectedItem.weave_method}</td>
                    <td>{selectedItem.knot_type}</td>
                    <td>{selectedItem.pile_material}</td>
                    <td>{selectedItem.warp_material}</td>
                    <td>{selectedItem.weft_material}</td>
                    <td>{selectedItem.number_weaver}</td>
                    <td>{selectedItem.number_color}</td>
                    <td>{selectedItem.ground_color}</td>
                    <td>{selectedItem.border_color}</td>
                  </tr>
                </tbody>
              </table>
            </>
          </Modal>
        )}
        {showDimensionsModal && (
          <Modal>
            <>
                          <button
              style={{width:50 , border:"none" }}
              onClick={() => setShowDimensionsModal(false)}
              >
                بستن
              </button>
              <table className="bi-table-style  col-12 col-md-6 col-lg-4">
                <thead>
                  <tr>
                    <th>عرض به سانتی متر</th>
                    <th>طول به سانتی متر</th>
                    <th>مساحت مترمربع</th>
                    <th>مبدا رج به سانتی متر</th>
                    <th>رج شمار</th>
                    <th>تراکم در دسی متر مربع</th>
                    <th>تعداد گره در عرض</th>
                    <th>تعداد گره در طول</th>
                    <th>تعداد کل گره</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{selectedItem.width}</td>
                    <td>{selectedItem.length}</td>
                    <td>{selectedItem.area}</td>
                    <td>{selectedItem.unit_raj}</td>
                    <td>{selectedItem.raj_counter}</td>
                    <td>{selectedItem.density}</td>
                    <td>{selectedItem.number_knots_width}</td>
                    <td>{selectedItem.number_knot_length}</td>
                    <td>{selectedItem.total_number_knot}</td>
                  </tr>
                </tbody>
              </table>

            </>
          </Modal>
        )}
        <div className="d-flex flex-row ">
          <Link to="/Certificate/Create-Certificate">
            <button className="bi-custom-button">اضافه کردن</button>
          </Link>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? setShowEditModal(true)
                : alert("جهت ویرایش یک آیتم را انتخاب کنید!")
            }
          >
            ویرایش
          </button>
          <button
            className="bi-custom-button"
            onClick={() =>
              selectedItem
                ? deleteItemHandler()
                : alert("جهت حذف یک آیتم را انتخاب کنید!")
            }
          >
            حذف
          </button>
        </div>
        {allCertificate === null ? (
          <Loading />
        ) : (
          <table className="bi-table-style bi-row-select-enable col-12 col-md-6 col-lg-4">
            <thead>
              <tr>
                <th>ایدی فرش</th>
                <th>شماره شناسنامه</th>
                <th>سریال شناسنامه</th>
                <th>کد فرش</th>
                <th>سال ایجاد</th>
                <th>طراح</th>
                <th>نوع طرح</th>
                <th>نام نقشه</th>
                <th>نفر ساعت تولید</th>
                <th>مدت زمان تولید-ماه</th>
                <th>وزن به کیلوگرم</th>
              </tr>
            </thead>

            <tbody>
              {allCertificate.map((Certificate) => {
                return (
                  <tr
                    id={Certificate.id}
                    onClick={() => handleSelectRow(Certificate)}
                    className={
                      selectedItem?.id === Certificate.id
                        ? "item-slected"
                        : null
                    }
                  >
                    <td>{Certificate.carpet_id}</td>
                    <td>{Certificate.certificate_number}</td>
                    <td>{Certificate.certificate_serial}</td>
                    <td>{Certificate.code}</td>
                    <td>{Certificate.years_creation}</td>
                    <td>{Certificate.designer}</td>
                    <td>{Certificate.design_type}</td>
                    <td>{Certificate.design_name}</td>
                    <td>{Certificate.man_hours_creation}</td>
                    <td>{Certificate.duration_creation}</td>
                    <td>{Certificate.weight}</td>
                    <td>
                      <button
                        className="bi-custom-button"
                        onClick={() => setShowOwnerModal(true)}
                      >
                        مشخصات مالک
                      </button>
                    </td>
                    <td>
                      <button
                        className="bi-custom-button"
                        onClick={() => setShowWeaveModal(true)}
                      >
                        مشخصات بافت
                      </button>
                    </td>
                    <td>
                      <button
                        className="bi-custom-button"
                        onClick={() => setShowDimensionsModal(true)}
                      >
                        ابعاد
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ShowCertificate;
